<div class='notification-container'>
  <div class='row'>
    <div class='col-12'>
      <app-alert
        *ngFor='let n of alertService.alerts(); let i = index'
        [closable]='dismissible'
        (onClose)='alertService.hide(i)'
        [type]='n.type'
        [content]='n.content'
        [alertTitle]='n.title'>
      </app-alert>
    </div>
  </div>
</div>
